import { reactive, ref, toRefs, Vue2 } from 'vue-demi'
import { useTable } from '@/utils/commonUse'
import service from '@/service/supervision/index'
import { EventBus } from '@/views/studentManage/studentAndGroup/studentDetails/event-bus'

/**
 * @description 获取学员列表
 * @param {根据小组筛选学员列表所需参数} param
 * @returns
 */
export function useGetStudentList (param, refs, methods) {
  const setInterval25 = ref(0)
  const state = reactive({
    studyingStudentNumber: undefined, // 正在学习人数
    studentTableLoading: false,
    // 课程列表数据
    studentList: []
  })
  const { scroll } = useTable()
  /**
   * @description 获取课程列表
   */
  const getStudentList = () => {
    state.courseTableLoading = true
    const arr = param.selectGroupObj.map(k => {
      const xkhTeacherCourseId = String(k.id).includes('_') ? k.id.split('_')[0] - 0 : k.id // 小组id
      const lessonId = String(k.id).includes('_') ? k.id.split('_')[1].split('*')[0] - 0 : null// 讲次id
      if (lessonId) {
        return { xkhTeacherCourseId, lessonId }
      }
      return { xkhTeacherCourseId }
    })

    /** Note: 入参错误引发的http响应状态400
     * 出现频率（近一年）： 异常/总数（418 / 368014）
     * pinpoint: https://iflow.dev.aixuexi.com/pinpoint/main/xkhWeb_sjr25@SPRING_BOOT/6h/2023-07-12-14-24-22
     * kibana: https://axx-kibana.aixuexi.com/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1y,to:now))&_a=(columns:!(_source),filters:!(),index:'952d3f20-f145-11eb-9a79-6771cdefb57e',interval:auto,query:(language:kuery,query:'%22teacherapi%2Fstudent%2Flesson%2FsuperviseClassList%22%20and%20status%20:%20400'),sort:!())
     * 测试环境未复现 400 状态
     * if (!arr || !Array.isArray(arr)) return // 可以前端校验参数先避免发出错误请求 ?
     *
     * 参数错误问题有时间可以排查处理
     */

    const httpParam = {
      groupIdToLessonIdMap: arr
    }
    service.getSupervisionStudentList(httpParam).then(res => {
      const { monitorList, studyingStudentNumber, systemTime } = res
      state.studentList = monitorList || []
      state.studyingStudentNumber = studyingStudentNumber
      EventBus.$emit('systemTime', systemTime)
      if (!param.refreshLoading) {
        Vue2.nextTick(() => methods.setScrollY())
      }
    }).catch(err => {
      console.error(err)
    }).finally(() => {
      state.courseTableLoading = false
      if (!setInterval25.value) {
        setInterval25.value = setInterval(() => {
          console.log('触发了')
          getStudentList()
        }, 25 * 1000)
      }
    })
  }

  const clearLoop25s = () => {
    clearInterval(setInterval25.value)
    setInterval25.value = null
  }

  return {
    ...toRefs(state),
    scroll,
    clearLoop25s,
    getStudentList
  }
}